import { Component, Event, EventEmitter, Listen, Prop, h } from '@stencil/core';
import { onSettingChange, settings } from '../../store/settings.store';
import { Space } from '@artask/tambr-models/models/spaces.model';

@Component({
  tag: 'tambr-space-info-dialog',
  styleUrl: 'tambr-space-info-dialog.css',
  shadow: true,
})
export class TambrSpaceInfoDialog {

  @Prop() spaceInfo: Space;
  @Event() tambrSpaceInfoClose: EventEmitter;

  @Listen('click') onClickEvent( ev: MouseEvent ) {
    const targets = ev.composedPath() as EventTarget[];
    if (targets[0] instanceof Element && targets[0].id === 'tambr-space-info') return this.close();
  }

  componentWillLoad() {
    onSettingChange( 'selectedView', selectedView => {
      if ( selectedView === 'card' ) {
        this.close();
      }
    });
  }

  close() {
    this.tambrSpaceInfoClose.emit();
  }

  render() {
    if ( !this.spaceInfo ) return;
    return (
      <div id='tambr-space-info' class="tambr-overlay">
        <div class="tambr-modal-window space-info-modal">

          { this.renderHeader() }

          { this.renderSpaceImages() }

          <div class="tambr-modal-body">
            <tambr-calendar-space-info space={ this.spaceInfo } type='dialog'></tambr-calendar-space-info>
          </div>
        </div>
      </div>
    )
  }

  renderHeader() {
    const showSpaceImages = settings.businessSettings.widgetLayoutSettings?.showSpaceImages?.includes('grid');
    if ( this.spaceInfo?.images?.filter( image => !!image.medium )?.length && showSpaceImages ) {
      return (
        <button class="tambr-arrow-button tambr-dialog-close" onClick={ () => this.close() }>
            <tambr-icon type="close" class="arrow close" />
        </button>
      )
    } else {
      return (
        <div class="tambr-modal-header">
          <tambr-icon type="close" class="close-button" onClick={ () => this.close() } />
        </div>
      )
    }
  }

  renderSpaceImages() {
    if ( !settings.businessSettings.widgetLayoutSettings?.showSpaceImages?.includes('grid') ) return;
    const images = this.spaceInfo.images?.filter( image => !!image.medium );
    if ( !images?.length ) return;
    return (
      <tambr-space-images type='dialog' images={ images }></tambr-space-images>
    )
  }

}
